import React, { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../../ProjectContext";
import axios from "axios";

function BonanzaReward() {
  const { account, useractivestatus } = useContext(ProjectContext);
  const [Data, setData] = useState([]);

  const getData = async () => {
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "bonanza",
        submethod: "getbyid",
        address: account,
        key: process.env.REACT_APP_KEY,
      });

      if (!res.data.error && Array.isArray(res.data.data)) {
        console.log("bonanza", res.data.data);
        setData(res.data.data); // ✅ Corrected here
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Error fetching bonanza data:", err);
    }
  };

  useEffect(() => {
    if (account) getData();
  }, [account]);

  return (
    <div className="py-0" style={{ minHeight: "0px" }}>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title text-white">Bonanza</h4>
              <button className="text-white btn-outline-bg-new-primary py-2 px-3" onClick={getData}>
                <i className="fa fa-refresh"></i>
              </button>
            </div>
            <div className="card-body">
              <div className="table-responsive" style={{ height: "370px" }}>
                <table className="table table-responsive-md">
                  <thead>
                    <tr>
                      <th><strong>#</strong></th>
                      <th><strong>REWARD</strong></th>
                      <th><strong>TEAM BUSINESS</strong></th>
                      <th><strong>LEVEL</strong></th>
                      <th><strong>DATE</strong></th>
                      <th><strong>STATUS</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data.length > 0 ? (
                      Data.map((user, index) => (
                        <tr key={user._id}>
                          <td><strong>{index + 1}</strong></td>
                          <td>$ {user.reward}</td>
                          <td>$ {user.team_business}</td>
                          <td>{user.level}</td>
                          <td>{new Date(user.date).toLocaleString()}</td>
                          <td>
                            <span className={`badge light ${user.status ? "badge-success" : "badge-danger"}`}>
                              {user.status ? "Received" : "Pending"}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BonanzaReward;
